import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

export default class CompAwareness extends React.Component {
  render() {
    return (
      <Svg width={38} height={34} viewBox="0 0 38 34" fill="none">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.913 0C1.955 0-2.742 8.924 1.74 15.524l4.303 6.343-4.814 7.703 5.738 3.605 4.323-6.915.235-.374h14.168l.236.374 4.323 6.915 5.738-3.605-4.815-7.703 4.304-6.343C39.958 8.944 35.262 0 27.303 0c-7.958 0-7.074 2.167-8.685 5.181C16.987 2.187 13.843 0 9.933 0h-.02zM6.455 12.234C4.805 9.79 6.533 6.5 9.48 6.5c2.947 0 4.637 3.191 3.085 5.654l-2.987 4.688-3.124-4.61zm24.287 0c1.65-2.443-.079-5.733-3.026-5.733-2.948 0-4.637 3.191-3.085 5.654l2.987 4.688 3.124-4.61zm-12.144 1.32l3.91 6.619h-7.82l3.91-6.62z"
          fill="#009CDE"
        />
      </Svg>
    );
  }
}
